module.exports = __webpack_public_path__ + "media/images/lb/721-f28adaf9b468ea420ce9f580b32d8c13.svg";